
import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { ObtenerTipoJuicio } from '../connections/catalogos/TipoJuicioConnection';
import { ObtenerEtapa } from '../connections/catalogos/EtapaConnection';
import { ObtenerSubEtapa } from '../connections/catalogos/SubEtapaConnection';
import { BuscarSecretariosAdmisibilidad, BuscarSecretariosEjecucion, BuscarSecretariosTramite, BuscarSecretariosTramiteMenor, ObtenerUsuarioJuez } from '../connections/admin/UsuarioConnection';
import { EditarExpediente } from '../connections/tribunal/ExpedienteVirtualConnection';

import { ExpedienteProps } from '../interfaces/tribunal/ExpedienteVirtualInterface';
import { TipoJuicioProps } from '../interfaces/catalogos/TipoJuicioInterface';
import { EtapaProps } from '../interfaces/catalogos/EtapaInterface';
import { SubEtapaProps } from '../interfaces/catalogos/SubEtapaInterface';
import { UsuarioJuezProps, UsuarioSecretarioProps } from '../interfaces/admin/UsuarioInterface';

interface Props {
    openDialog:         boolean;
    handleCloseDialog:  () => void;
    expediente:         ExpedienteProps;
    onGuardar:          ( expediente: ExpedienteProps ) => void;
}

export const DialogEditarExpediente = ( { openDialog, handleCloseDialog, expediente, onGuardar }: Props ) => {

    const dispatch = useDispatch();

    const [guardando, setGuardando] = useState( false );

    const [cuantiaEditada, setCuantiaEditada] = useState( '' );

    const [tipoJuicioArray, setTipoJuicioArray] = useState<TipoJuicioProps[]>( [] );
    const [etapaArray, setEtapaArray] = useState<EtapaProps[]>( [] );
    const [subEtapaArray, setSubEtapaArray] = useState<SubEtapaProps[]>( [] );
    const [juezArray, setJuezArray] = useState<UsuarioJuezProps[]>( [] );
    const [secretariosAdmisibilidadArray, setSecretariosAdmisibilidadArray] = useState<UsuarioSecretarioProps[]>( [] );
    const [secretariosTramiteArray, setSecretariosTramiteArray] = useState<UsuarioSecretarioProps[]>( [] );
    const [secretariosTramiteMenorArray, setSecretariosTramiteMenorArray] = useState<UsuarioSecretarioProps[]>( [] );
    const [secretariosEjecucionArray, setSecretariosEjecucionArray] = useState<UsuarioSecretarioProps[]>( [] );

    const [tipoJuicioEditado, setTipoJuicioEditado] = useState( 0 );
    const [etapaEditada, setEtapaEditada] = useState( 0 );
    const [subEtapaEditada, setSubEtapaEditada] = useState( 0 );
    const [subEtapaEditadaTemp, setSubEtapaEditadaTemp] = useState( 0 );
    const [juezEditado, setJuezEditado] = useState( 0 );
    const [secretarioAdmisibilidadEditado, setSecretarioAdmisibilidadEditado] = useState( 0 );
    const [secretarioTramiteEditado, setSecretarioTramiteEditado] = useState( 0 );
    const [secretarioTramiteMenorEditado, setSecretarioTramiteMenorEditado] = useState( 0 );
    const [secretarioEjecucionEditado, setSecretarioEjecucionEditado] = useState( 0 );
    const [medioImpugnacionEditado, setMedioImpugnacionEditado] = useState( false );
    const [incidenteEditado, setIncidenteEditado] = useState( false );

    const handleGuardar = async () => {

        setGuardando( true );

        const tipoJuicioDescripcion = tipoJuicioArray.find( ({ idTipoJuicio }) => idTipoJuicio === tipoJuicioEditado )?.descripcion ?? '';
        const etapaDescripcion = etapaArray.find( ({ idEtapa }) => idEtapa === etapaEditada )?.descripcion ?? '';
        const subEtapaDescripcion = subEtapaArray.find( ({ idSubEtapa }) => idSubEtapa === subEtapaEditada )?.descripcion ?? '';
        const juezDescripcion = juezArray.find( ({ idUsuario }) => idUsuario === juezEditado )?.nombreCompleto ?? '';
        const secretarioAdmisibilidadDescripcion = secretariosAdmisibilidadArray.find( ({ id }) => id === secretarioAdmisibilidadEditado )?.nombreCompleto ?? '';
        const secretarioTramiteDescripcion = secretariosTramiteArray.find( ({ id }) => id === secretarioTramiteEditado )?.nombreCompleto ?? '';
        const secretarioTramiteMenorDescripcion = secretariosTramiteMenorArray.find( ({ id }) => id === secretarioTramiteMenorEditado )?.nombreCompleto ?? '';
        const secretarioEjecucionDescripcion = secretariosEjecucionArray.find( ({ id }) => id === secretarioEjecucionEditado )?.nombreCompleto ?? '';

        await EditarExpediente({
            idExpediente:               expediente.idExpediente,
            idTipoJuicio:               tipoJuicioEditado,
            idJuez:                     juezEditado,
            idSecretarioAdmisibilidad:  secretarioAdmisibilidadEditado,
            idSecretarioTramite:        secretarioTramiteEditado,
            idSecretarioTramiteMenor:   secretarioTramiteMenorEditado,
            idSecretarioEjecucion:      secretarioEjecucionEditado,
            cuantia:                    cuantiaEditada,
            idEtapa:                    etapaEditada,
            idSubEtapa:                 subEtapaEditada,
            medioImpugnacion:           medioImpugnacionEditado,
            incidente:                  incidenteEditado,
        }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    onGuardar({
                        ...expediente,
                        cuantia:                    cuantiaEditada,
                        idTipoJuicio:               tipoJuicioEditado,
                        tipoJuicio:                 tipoJuicioDescripcion,
                        idEtapa:                    etapaEditada,
                        etapa:                      etapaDescripcion,
                        idSubEtapa:                 subEtapaEditada,
                        subEtapa:                   subEtapaDescripcion,
                        idJuez:                     juezEditado,
                        juez:                       juezDescripcion,
                        idSecretarioAdmisibilidad:  secretarioAdmisibilidadEditado,
                        secretarioAdmisibilidad:    secretarioAdmisibilidadDescripcion,
                        idSecretarioTramite:        secretarioTramiteEditado,
                        secretarioTramite:          secretarioTramiteDescripcion,
                        idSecretarioTramiteMenor:   secretarioTramiteMenorEditado,
                        secretarioTramiteMenor:     secretarioTramiteMenorDescripcion,
                        idSecretarioEjecucion:      secretarioEjecucionEditado,
                        secretarioEjecucion:        secretarioEjecucionDescripcion,
                        medioImpugnacion:           medioImpugnacionEditado,
                        incidente:                  incidenteEditado,
                    });

                    dispatch( openSnackbar({ message, variant: 'success' }) );
                    handleCloseDialog();

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

                setGuardando( false );

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener(){
            await ObtenerTipoJuicio().then( resp => {
                setTipoJuicioArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerEtapa().then( resp => {
                setEtapaArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await ObtenerUsuarioJuez().then( resp => {
                setJuezArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await BuscarSecretariosAdmisibilidad().then( resp => {
                setSecretariosAdmisibilidadArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await BuscarSecretariosTramite().then( resp => {
                setSecretariosTramiteArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await BuscarSecretariosTramiteMenor().then( resp => {
                setSecretariosTramiteMenorArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener(){
            await BuscarSecretariosEjecucion().then( resp => {
                setSecretariosEjecucionArray( resp );
            });
        }

        Obtener();

    }, []);

    useEffect(() => {

        if( openDialog ){

            setCuantiaEditada( expediente.cuantia );
            setTipoJuicioEditado( expediente.idTipoJuicio );
            setEtapaEditada( expediente.idEtapa );
            setSubEtapaEditadaTemp( expediente.idSubEtapa );
            setJuezEditado( expediente.idJuez );
            setSecretarioAdmisibilidadEditado( expediente.idSecretarioAdmisibilidad );
            setSecretarioTramiteEditado( expediente.idSecretarioTramite );
            setSecretarioTramiteMenorEditado( expediente.idSecretarioTramiteMenor );
            setSecretarioEjecucionEditado( expediente.idSecretarioEjecucion );
            setMedioImpugnacionEditado( expediente.medioImpugnacion );
            setIncidenteEditado( expediente.incidente );

        }

    }, [ openDialog, expediente ]);

    useEffect(() => {

        async function Obtener(){

            setSubEtapaEditada( 0 );
            setSubEtapaArray( [] );

            await ObtenerSubEtapa( etapaEditada ).then( resp => {
                setSubEtapaArray( resp );
            });

        }

        if( etapaEditada !== 0 ){
            Obtener();
        }

    }, [ etapaEditada ]);

    useEffect(() => {

        if( subEtapaEditadaTemp !== 0 && subEtapaArray.length !== 0 ){
            setSubEtapaEditada( subEtapaEditadaTemp );
        }

    }, [ subEtapaEditadaTemp, subEtapaArray.length ]);

    return (

        <Dialog
            fullWidth
            maxWidth='md'
            open={ openDialog }
            onClose={ () => {} }
        >

            <DialogTitle>Editar expediente</DialogTitle>

            <DialogContent>

                <Grid container spacing={3} sx={{ mt: 1 }}>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <TextField
                            fullWidth
                            label='Cuantía'
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                }
                            }}
                            value={ cuantiaEditada }
                            onChange={ (e) => setCuantiaEditada( e.target.value ) }
                        />

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Tipo de juicio</InputLabel>

                            <Select
                                notched
                                label='Tipo de juicio'
                                value={ tipoJuicioEditado }
                                onChange={ (e) => setTipoJuicioEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    tipoJuicioArray.map( ({ idTipoJuicio, descripcion }) => (
                                        <MenuItem key={ idTipoJuicio } value={ idTipoJuicio }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Etapa</InputLabel>

                            <Select
                                notched
                                label='Etapa'
                                value={ etapaEditada }
                                onChange={ (e) => { setSubEtapaEditada( 0 ); setEtapaEditada( e.target.value as number ); } }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    etapaArray
                                    .filter( ({ idEtapa }) => idEtapa !== 14 && idEtapa !== 17 && idEtapa !== 18 )
                                    .map( ({ idEtapa, descripcion }) => (
                                        <MenuItem key={ idEtapa } value={ idEtapa }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Subetapa</InputLabel>

                            <Select
                                notched
                                label='Subetapa'
                                value={ subEtapaEditada }
                                onChange={ (e) => setSubEtapaEditada( e.target.value as number ) }
                                disabled={ etapaEditada === 0 || subEtapaArray.length === 0 }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    subEtapaArray.map( ({ idSubEtapa, descripcion }) => (
                                        <MenuItem key={ idSubEtapa } value={ idSubEtapa }>{ descripcion }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>
                    
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Juez</InputLabel>

                            <Select
                                notched
                                label='Juez'
                                value={ juezEditado }
                                onChange={ (e) => setJuezEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    juezArray.map( ({ idUsuario, nombreCompleto }) => (
                                        <MenuItem key={ idUsuario } value={ idUsuario }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>                    
                    
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Secretario(a) de admisibilidad</InputLabel>

                            <Select
                                notched
                                label='Secretario(a) de admisibilidad'
                                value={ secretarioAdmisibilidadEditado }
                                onChange={ (e) => setSecretarioAdmisibilidadEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    secretariosAdmisibilidadArray.map( ({ id, nombreCompleto }) => (
                                        <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>   
            
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Secretario(a) de trámite</InputLabel>

                            <Select
                                notched
                                label='Secretario(a) de trámite'
                                value={ secretarioTramiteEditado }
                                onChange={ (e) => setSecretarioTramiteEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    secretariosTramiteArray.map( ({ id, nombreCompleto }) => (
                                        <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>  

                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Secretario(a) de trámite (menor cuantía)</InputLabel>

                            <Select
                                notched
                                label='Secretario(a) de trámite (menor cuantía)'
                                value={ secretarioTramiteMenorEditado }
                                onChange={ (e) => setSecretarioTramiteMenorEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    secretariosTramiteMenorArray.map( ({ id, nombreCompleto }) => (
                                        <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>              
        
                    <Grid size={{ md: 6, xs: 12 }}>

                        <FormControl fullWidth>

                            <InputLabel shrink>Secretario(a) de ejecución</InputLabel>

                            <Select
                                notched
                                label='Secretario(a) de ejecución'
                                value={ secretarioEjecucionEditado }
                                onChange={ (e) => setSecretarioEjecucionEditado( e.target.value as number ) }
                            >
                                <MenuItem value={0}>Selecciona una opción</MenuItem>
                                {
                                    secretariosEjecucionArray.map( ({ id, nombreCompleto }) => (
                                        <MenuItem key={ id } value={ id }>{ nombreCompleto }</MenuItem>
                                    ))
                                }
                            </Select>

                        </FormControl>

                    </Grid>

                    <Grid size={{ md: 12, xs: 12 }}>

                        <Grid container spacing={3}>

                            <Grid size={{ md: 6, xs: 12 }}>

                                <FormControlLabel
                                    label='Medio de impugnación'
                                    control={
                                        <Checkbox
                                            checked={ medioImpugnacionEditado }
                                            onChange={ (e) => setMedioImpugnacionEditado( e.target.checked ) }
                                        />
                                    }
                                />

                            </Grid>

                            <Grid size={{ md: 6, xs: 12 }}>

                                <FormControlLabel
                                    label='Incidente'
                                    control={
                                        <Checkbox
                                            checked={ incidenteEditado }
                                            onChange={ (e) => setIncidenteEditado( e.target.checked ) }
                                        />
                                    }
                                />

                            </Grid>

                        </Grid>

                    </Grid>

                </Grid>

            </DialogContent>

            <DialogActions>
                <Button color='secondary' onClick={ handleCloseDialog } disabled={ guardando }>Cancelar</Button>
                <Button variant='contained' loading={ guardando } onClick={ handleGuardar }>Guardar</Button>
            </DialogActions>

        </Dialog>

    );

}
